import React from 'react';

const FormContext = React.createContext({
  mobile: true,
  isDetail: false,
});
export default FormContext;
